import { useState } from "react";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2, UserRound } from "lucide-react";
import { Input } from "@/components/ui/input";

const INTERESTS = [
  "Neurosciences", "Émotions & comportements", "Langage & motricité",
  "Santé, nutrition & sommeil", "Jeu & apprentissages", "Attachement",
  "Aménagement de l'espace", "Direction & équipes",
];

export const MemberProfileCard = () => {
  const { user } = useAuth();
  const [profession, setProfession] = useState(user?.profession || "");
  const [interests, setInterests] = useState(user?.interests || []);
  const [saving, setSaving] = useState(false);

  const toggle = (i) => setInterests((cur) => (cur.includes(i) ? cur.filter((x) => x !== i) : [...cur, i]));

  const save = async () => {
    setSaving(true);
    try {
      await http.patch("/me/profile", { profession, interests });
      toast.success("Profil mis à jour", { description: "Vos centres d'intérêt ont bien été enregistrés." });
    } catch {
      toast.error("Erreur lors de l'enregistrement");
    } finally { setSaving(false); }
  };

  return (
    <div className="card-soft p-7 mt-10" data-testid="member-profile-card">
      <div className="flex items-center gap-3 mb-4">
        <div className="grid place-items-center h-10 w-10 rounded-2xl bg-brand-100 text-brand-700"><UserRound size={18} strokeWidth={1.75} /></div>
        <div>
          <h2 className="font-display font-bold text-lg text-slate-900">Mon profil membre</h2>
          <p className="text-xs text-slate-500">Renseignez vos informations et vos centres d'intérêt.</p>
        </div>
      </div>
      <div className="grid gap-4">
        <div className="max-w-sm">
          <label className="text-xs font-semibold uppercase tracking-widest text-slate-500">Profession / fonction</label>
          <Input data-testid="profile-profession" className="mt-1.5" placeholder="Votre profession" value={profession} onChange={(e) => setProfession(e.target.value)} />
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest text-slate-500">Centres d'intérêt</label>
          <div className="mt-2 flex flex-wrap gap-2">
            {INTERESTS.map((i) => (
              <button key={i} type="button" onClick={() => toggle(i)} data-testid={`interest-${i.split(" ")[0].toLowerCase()}`}
                className={`rounded-full px-4 py-2 text-xs font-semibold transition-colors ${interests.includes(i) ? "bg-brand-500 text-white" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}>
                {i}
              </button>
            ))}
          </div>
        </div>
        <button data-testid="profile-save" onClick={save} disabled={saving} className="btn-primary w-fit text-sm disabled:opacity-70">
          {saving ? <Loader2 size={15} className="animate-spin" /> : "Enregistrer mon profil"}
        </button>
      </div>
    </div>
  );
};
